class EventSource {
  constructor(genericErrorHandler) {
    this._errorHandler = genericErrorHandler || console.error.bind(console, 'Event subscriber threw error');
    this._listeners = [];

    this.subscribe = this.subscribe.bind(this);
  }

  publish(...args) {
    this._listeners.forEach(callback => {
      try {
        callback(...args);
      }
      catch (ex) {
        this._errorHandler(ex);
      }
    });
  }

  subscribe(callback) {
    if (typeof callback !== 'function') {
      throw new Error('callback must be a function.');
    }

    this._listeners.push(callback);

    return () => {
      this._listeners = this._listeners.filter(x => x !== callback);
    };
  }
}

export default EventSource;
